import { render } from "./subordinateUsers.vue?vue&type=template&id=40054f88&scoped=true"
import script from "./subordinateUsers.vue?vue&type=script&lang=js"
export * from "./subordinateUsers.vue?vue&type=script&lang=js"

import "./subordinateUsers.vue?vue&type=style&index=0&id=40054f88&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40054f88"]])

export default __exports__